import axios from "axios";
import { __api } from '../config';

export const baseDomain = __api();
// The base URL is empty this time due we are using the jsonplaceholder API
const baseURL = `${baseDomain}`;

// var cookieValue = "";
// if (document.cookie != "") {https://tna.topnotchathletes.com
//   cookieValue = document.cookie
//     .split(";")
//     .find(v => v.startsWith("token"))
//     .split("=")[1];
// } else {
//   cookieValue = "";
// }

export default {
  sendReq({ method, subUrl, data = null, params = null }) {
    return new Promise((resolve, reject) => {
      // axios.defaults.withCredentials = true;
      axios({
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`
        },
        method,
        url: `${baseURL}${subUrl}`,
        data,
        params
      })
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }
};
